var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-footer navbar-bottom"},[_c('div',{staticClass:"mt-3"},[_c('p',[_vm._v("© QuickTest")]),_c('p',{staticClass:"underline font-bold text-green-500"},[_vm._v("Built with "),_c('img',{attrs:{"src":require("@/assets/love.png")}}),_vm._v(" by Perominc Technologies")])])])
}]

export { render, staticRenderFns }